import './src/styles/global.css';
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

export const onClientEntry = () => {
  window.___gatsby_scroll = { disable: true };
};

export const onRouteUpdate = () => {
  window.scrollTo(0, 0);
};
